import React from 'react'

import { FunctionCall } from '../helper/FunctionCall'
import Milliseconds from '../helper/milliseconds'
import Percent from '../helper/percent'
import { BoxBody, BoxHeader, BoxTitle } from '../ui/box'
import { XhprofCallInfo } from '../xhprof/XhprofReportGenerator'

interface Props {
    select: (call: string) => void
    title: string | null
    showToggle: boolean
    calls: { [name: string]: XhprofCallInfo }
    compareMode: boolean
}

class CallTable extends React.Component<Props> {
    public static defaultProps = {
        showToggle: true,
        compareMode: false,
    }

    public render() {
        if (!this.props.calls || !Object.keys(this.props.calls).length) {
            return <p className="text-center tw-p-8">No Entries</p>
        }

        return (
            <>
                {this.props.title ? (
                    <BoxHeader>
                        <BoxTitle>{this.props.title}</BoxTitle>
                    </BoxHeader>
                ) : null}

                <BoxBody noPadding>
                    <table className="table table-striped table-bordered profile">
                        <thead>
                            <tr>
                                <th>Function Name</th>
                                <th className="number">Calls</th>
                                <th className="number">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(this.props.calls).map(([call, stats]: [string, XhprofCallInfo]) => (
                                <tr key={call}>
                                    <td>
                                        <a onClick={() => this.props.select(call)}>
                                            <FunctionCall call={call} maxWidth={300} />
                                        </a>
                                    </td>
                                    <td className="number">{stats.ct}</td>
                                    <td className="number">
                                        <Milliseconds value={stats.wt} showPlusSign={this.props.compareMode} />
                                        <br />
                                        <span className="text-mute">
                                            <Percent
                                                value={stats && stats.perc_wt ? stats.perc_wt / 100 : 0}
                                                showPlusSign={this.props.compareMode}
                                            />
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </BoxBody>
            </>
        )
    }
}

export default CallTable
